import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const ScrollToTop = ({ color }) => {
  const { t } = useTranslation();

  return (
    <svg
      alt="scroll to top"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      role="img"
    >
      <title>{t('Scroll To Top Icon')}</title>
      <defs />
      <path
        fill={color}
        className="a"
        d="M16,32A16,16,0,1,1,32,16,16.019,16.019,0,0,1,16,32ZM16,2A14,14,0,1,0,30,16,14.015,14.015,0,0,0,16,2Zm5,17a1,1,0,0,1-.707-.293L16,14.414l-4.293,4.293a1,1,0,0,1-1.414-1.414l5-5a1,1,0,0,1,1.414,0l5,5A1,1,0,0,1,21,19Zm-5,6a1,1,0,0,1-1-1V13a1,1,0,0,1,2,0V24A1,1,0,0,1,16,25Zm6-15H10a1,1,0,0,1,0-2H22a1,1,0,0,1,0,2Z"
      />
    </svg>
  );
};

export default ScrollToTop;

ScrollToTop.propTypes = {
  color: PropTypes.string.isRequired,
};
